export enum DiscoverTypeEnum {
  country,
  circle
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/enums/discoverType.enum.ts